import React, { memo, SVGProps } from 'react'

export const CheckmarkBold = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.8717 7.70592L10.3373 13.2394L8.12736 11.0294C7.5648 10.4669 6.65376 10.4669 6.0912 11.0294C5.52864 11.592 5.52864 12.503 6.0912 13.0656L9.31872 16.2931C9.6 16.5744 9.96864 16.7146 10.3373 16.7146C10.7059 16.7146 11.0746 16.5744 11.3558 16.2931L17.9078 9.74208C18.4704 9.17952 18.4704 8.26848 17.9078 7.70592C17.3453 7.14336 16.4342 7.14336 15.8717 7.70592Z"
      fill="currentColor"
    />
  </svg>
))
